<template>
  <AdBanner :ads="ads" />
</template>

<script>
import AdBanner from '@/components/sections/AdBanner.vue'

export default {
  name: 'SectionAd',
  components: { AdBanner },
  computed: {
    ads() {
      const key = (this.$route.name ?? '').split(':')[0]

      return this.$beet?.ads?.site?.[key]?.flex ?? []
    },
  },
}
</script>
